import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

function normalizeAxiosError(e) {
    return e?.response?.data?.error || e?.message || "Unbekannter Fehler";
}

export default function useCategories() {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchCategories = useCallback(async () => {
        setLoading(true);
        setError("");
        try {
            const res = await axios.get(`${API_BASE}/api/categories`, { withCredentials: true });
            const data = res.data?.categories ?? res.data ?? [];
            setCategories(Array.isArray(data) ? data : []);
        } catch (e) {
            setError(normalizeAxiosError(e));
        } finally {
            setLoading(false);
        }
    }, []);

    const createCategory = useCallback(async (payload) => {
        try {
            const res = await axios.post(`${API_BASE}/api/categories`, payload, { withCredentials: true });
            await fetchCategories();
            return res.data?.category;
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchCategories]);

    const updateCategory = useCallback(async (id, payload) => {
        try {
            const res = await axios.put(`${API_BASE}/api/categories/${id}`, payload, { withCredentials: true });
            await fetchCategories();
            return res.data?.category;
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchCategories]);

    const deleteCategory = useCallback(async (id) => {
        try {
            await axios.delete(`${API_BASE}/api/categories/${id}`, { withCredentials: true });
            await fetchCategories();
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchCategories]);

    useEffect(() => {
        fetchCategories();
    }, [fetchCategories]);

    return {
        categories,
        loading,
        error,
        fetchCategories,
        createCategory,
        updateCategory,
        deleteCategory,
    };
}
